// src/router/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Protege por sesión y opcionalmente por roles.
 * - AuthProvider restaura la sesión; si no existe, manda a /login.
 * - Si hay allowRoles: sólo deja pasar si el usuario tiene al menos uno.
 *
 * Props:
 *  - allowRoles?: string[]  (ej. ["ADMIN"])
 *  - fallback?: string      (a dónde redirigir si no cumple roles, por defecto "/assignments")
 */
export default function ProtectedRoute({ children, allowRoles, fallback = "/assignments" }) {
  const { me, roles, loading } = useAuth(); // me y roles vienen de /users/me
  const location = useLocation();

  if (loading) return null;

  if (!me) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (Array.isArray(allowRoles) && allowRoles.length > 0) {
    const ok = (roles || []).some((r) => allowRoles.includes(r));
    if (!ok) return <Navigate to={fallback} replace />;
  }

  return children;
}
